// @flow

import React from 'react'
import Container from './Container'
import Appear from './Appear'
import { markdown } from 'markdown'

type Props = {
  text: string,
}

const Text = ({ text }: Props) => {
  return (
    <Appear>
      <Container className="mb-16 text-lg md:text-base">
        {text && 
          <div dangerouslySetInnerHTML={{ __html: markdown.toHTML(text) }} />
        }
      </Container>
    </Appear>
  )
}

export default Text
